/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-04-04",
    versionChannel: "nightly",
    buildDate: "2024-04-04T00:05:40.274Z",
    commitHash: "51d91b2c1757b79662379f126d4561265890fd10",
};
